var _path, _path2, _path3, _g, _rect, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2997 15.9837L41.2997 15.9837V15.9885V25.971C41.2997 27.008 40.4762 27.8132 39.5927 27.8132H29.9842C29.0992 27.8132 28.2771 27.0096 28.2771 25.971V13.5423C28.2771 12.5036 29.0992 11.7001 29.9842 11.7001H37.2765V11.7001L37.2819 11.7C37.5779 11.6978 37.8708 11.8185 38.0948 12.0491L40.9538 15.0687C41.174 15.3072 41.3021 15.6354 41.2997 15.9837Z",
    fill: "#F5F5F5",
    stroke: "#50595F",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5112 18.2503L38.5111 18.2503V18.2551V28.2376C38.5111 29.2746 37.6876 30.0798 36.8041 30.0798H27.1956C26.3106 30.0798 25.4886 29.2762 25.4886 28.2376V15.8089C25.4886 14.7702 26.3106 13.9667 27.1956 13.9667H34.488V13.9667L34.4933 13.9666C34.7894 13.9644 35.0822 14.0851 35.3062 14.3157L38.1652 17.3353C38.3854 17.5738 38.5136 17.902 38.5112 18.2503Z",
    fill: "#FBFBFB",
    stroke: "#50595F",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7226 20.5164L35.7226 20.5164V20.5212V30.5037C35.7226 31.5407 34.899 32.3459 34.0155 32.3459H24.4071C23.522 32.3459 22.7 31.5423 22.7 30.5037V18.075C22.7 17.0363 23.522 16.2328 24.4071 16.2328H31.6994V16.2328L31.7047 16.2327C32.0008 16.2305 32.2936 16.3512 32.5177 16.5818L35.3767 19.6014C35.5968 19.8399 35.725 20.1681 35.7226 20.5164Z",
    fill: "white",
    stroke: "#50595F",
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4104_2009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4997 59.985L41.4997 59.985V59.9885V69.971C41.4997 71.1087 40.5961 72.0132 39.5927 72.0132H29.9842C28.9792 72.0132 28.0771 71.1103 28.0771 69.971V57.5423C28.0771 56.4029 28.9792 55.5001 29.9842 55.5001L37.2765 55.5001L37.2804 55.5C37.6331 55.4973 37.9782 55.6416 38.2392 55.9107L41.0999 58.932C41.356 59.209 41.5025 59.587 41.4997 59.985Z",
    fill: "url(#paint0_linear_4104_2009)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7112 62.2516L38.7111 62.2516V62.2551V72.2376C38.7111 73.3753 37.8076 74.2798 36.8041 74.2798H27.1956C26.1906 74.2798 25.2886 73.3769 25.2886 72.2376V59.8089C25.2886 58.6695 26.1906 57.7667 27.1956 57.7667L34.488 57.7667L34.4918 57.7666C34.8445 57.7639 35.1897 57.9082 35.4506 58.1773L38.3113 61.1986C38.5674 61.4756 38.7139 61.8536 38.7112 62.2516Z",
    fill: "url(#paint1_linear_4104_2009)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9226 64.5177L35.9226 64.5177V64.5212V74.5037C35.9226 75.6414 35.019 76.5459 34.0155 76.5459H24.4071C23.402 76.5459 22.5 75.643 22.5 74.5037V62.075C22.5 60.9356 23.402 60.0328 24.4071 60.0328L31.6994 60.0328L31.7032 60.0328C32.0559 60.03 32.4011 60.1743 32.6621 60.4435L35.5227 63.4647C35.7788 63.7417 35.9253 64.1198 35.9226 64.5177Z",
    fill: "url(#paint2_linear_4104_2009)",
    stroke: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2997 103.984L41.2997 103.984V103.988V113.971C41.2997 115.008 40.4762 115.813 39.5927 115.813H29.9842C29.0992 115.813 28.2771 115.01 28.2771 113.971V101.542C28.2771 100.504 29.0992 99.7001 29.9842 99.7001H37.2765V99.7001L37.2819 99.7C37.5779 99.6978 37.8708 99.8185 38.0948 100.049L40.9538 103.069C41.174 103.307 41.3021 103.635 41.2997 103.984Z",
    fill: "#F5F5F5",
    stroke: "#CBD5DC",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5112 106.25L38.5111 106.25V106.255V116.238C38.5111 117.275 37.6876 118.08 36.8041 118.08H27.1956C26.3106 118.08 25.4886 117.276 25.4886 116.238V103.809C25.4886 102.77 26.3106 101.967 27.1956 101.967H34.488V101.967L34.4933 101.967C34.7894 101.964 35.0822 102.085 35.3062 102.316L38.1652 105.335C38.3854 105.574 38.5136 105.902 38.5112 106.25Z",
    fill: "#FBFBFB",
    stroke: "#CBD5DC",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7226 108.516L35.7226 108.516V108.521V118.504C35.7226 119.541 34.899 120.346 34.0155 120.346H24.4071C23.522 120.346 22.7 119.542 22.7 118.504V106.075C22.7 105.036 23.522 104.233 24.4071 104.233H31.6994V104.233L31.7047 104.233C32.0008 104.23 32.2936 104.351 32.5177 104.582L35.3767 107.601C35.5968 107.84 35.725 108.168 35.7226 108.516Z",
    fill: "white",
    stroke: "#CBD5DC",
    strokeWidth: 1.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4104_2009",
    x: 18,
    y: 53,
    width: 28,
    height: 30.0459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4104_2009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4104_2009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4104_2009",
    x1: 34.7885,
    y1: 55,
    x2: 34.7885,
    y2: 72.5132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4104_2009",
    x1: 31.9999,
    y1: 57.2666,
    x2: 31.9999,
    y2: 74.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4104_2009",
    x1: 29.2113,
    y1: 59.5327,
    x2: 29.2113,
    y2: 77.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.5a10bd19d3cde3a1f3ee199d93b7b108.svg";
export { ForwardRef as ReactComponent };